import React, { useState } from 'react';
// import Select, { MultiValue, SingleValue, SingleValueProps, components } from 'react-select';
import Select, { MultiValue, SingleValue,components, SingleValueProps, StylesConfig,} from 'react-select';
import InfoBar from '../InfoBars';
import './SelectionItemDropDown.css';


interface OptionType {
  value: string;
  label: string;
}
interface DropDownProps {
  dropDownType?: 'error' | 'success' | 'entered' | 'general';
  options?: any;
  placeHolder?: string;
  dropDownClick: (value:boolean) => void;
  multipleSelection?: boolean;
  dropDownDisable: boolean;
  afterFocus?: string;
  dropLabelName?: string;
  ifRequired?: boolean;
  className?: string;
  dropdownsearchable?: boolean;
  defaultValue?: string | any;
  value?: any;
  style?: any;
  isClearable? : boolean
  savedItems?: {[key: string]: string};
  errorMessage?:string;
}
const SelectionItemDropDown: React.FC<DropDownProps> = ({
  dropDownType,
  options,
  placeHolder,
  dropDownClick,
  multipleSelection,
  dropDownDisable,
  afterFocus,
  dropLabelName,
  ifRequired,
  className,
  dropdownsearchable,
  value,
  style,
  isClearable= true,
  defaultValue,
  savedItems,
  errorMessage
}) => {
 

  const options1=savedItems ?Object.values(savedItems) :null;
  const displayValue=options1===null?'':options1.join(', ');

  {
    if (dropDownType === 'error') {
      afterFocus = 'red';
    } else if (dropDownType === 'success') {
      afterFocus = 'green';
    } else if (dropDownType === 'entered') {
      afterFocus = 'blue';
    } else {
      afterFocus = '';
    }
  }
  const handleDropDownClick=()=>{
    dropDownClick(true);
  }
  return (
    <div className={`multi-select-group-${dropDownType} ${className}`}>
      {dropLabelName && (
        <label
          className={`drop-name-required-for-ip ${ifRequired && 'yes'}`}
        >
          {dropLabelName}
        </label>
      )}
      <div onClick={handleDropDownClick}>
      <Select
        className={`selection_modal_dropdown multi-select-dropdown ${dropDownDisable} ${displayValue && 'yes'}`}
        classNamePrefix="multi-select"
        isMulti={multipleSelection}
        placeholder={displayValue?displayValue:placeHolder}
        hideSelectedOptions={false}
        isDisabled={true}
        isSearchable={dropdownsearchable}
        defaultValue={defaultValue}
        value={null}
        isClearable={isClearable}
        styles={{
          placeholder: () => ({
            marginLeft: 10,
            color: 'rgba(179, 179, 179, 1)',
            fontWeight: 400,
            fontSize: 12,
          }),
          valueContainer: () => ({
            display: 'flex',
            alignItems:'center',
            flexWrap: 'nowrap',
            overflow: 'overlay',
            marginLeft: 7,
          }),
          control: (baseStyles, state) => ({
            ...baseStyles,
            borderColor: state.isFocused ? afterFocus : 'grey',
            '&:hover': {
              borderColor: state.isFocused ? afterFocus : 'grey',
            },
            flexWrap: state.isFocused ? 'nowrap' : 'nowrap',
            boxShadow: state.isFocused ? 'none' : 'none',
          }),
        }}
      />
      </div>
      <div className="searchable_drop_down_infoBars">
        {dropDownType === 'success' ? (
          <InfoBar
            variant="success"
            message={errorMessage?errorMessage:''}
            className="searchable_drop_down_class"
          />
        ) : (
          ''
        )}
        {dropDownType === 'error' ? (
          <InfoBar
            variant="danger"
            message={errorMessage?errorMessage:''}
            className="searchable_drop_down_class"
          />
        ) : (
          ''
        )}
      </div>
    </div>
  );
};

export default SelectionItemDropDown;
